export const WISHLIST_REQUEST = "WISHLIST_REQUEST";
export const WISHLIST_SUCCESS = "WISHLIST_SUCCESS";
export const WISHLIST_ERROR = "WISHLIST_ERROR";

export const PATCH_WISHLIST_REQUEST = "PATCH_WISHLIST_REQUEST";
export const PATCH_WISHLIST_SUCCESS = "PATCH_WISHLIST_SUCCESS";
export const PATCH_WISHLIST_ERROR = "PATCH_WISHLIST_ERROR";



export const REMOVE_WISHLIST_REQUEST = "REMOVE_WISHLIST_REQUEST";
export const REMOVE_WISHLIST_SUCCESS = "REMOVE_WISHLIST_SUCCESS";
export const REMOVE_WISHLIST_ERROR = "REMOVE_WISHLIST_ERROR";
